$(document).on("click", ".custom_item_button", function () {
  var variantId = $(this).attr("data-variant-id");
  var item = {};
  var this_cart =
    document.querySelector("cart-notification") ||
    document.querySelector("cart-drawer");
  item.id = variantId;
  item.quantity = 1;
  item.sections = this_cart.getSectionsToRender().map((section) => section.id);
  var data = item;
  $.ajax({
    type: "post",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function (response) {
     
      window.location.href = "/cart";
    },
  });
});

$(".crossSell--itemSelector").on("change", function (params) {
  var value = $(this).val();

  $(this)
    .parents(".cross_item_info")
    .find(".custom_item_button")
    .attr("data-variant-id", value);
});

// Track sticky state outside the scroll event
let isSticky = false;
if($('.sticky--atc-wrapper').length > 0 ){
  $(window).scroll(function() {
  if($('.atc-broker').length > 0 ){
    var ScrollElement = $(this).scrollTop();
    var headerHeight = $('header').height();
    var ButtonHeight = $('sticky-atc').height();
    var ButtonOffSet = $('sticky-atc').offset().top;
    
    let TotalElementHeight = headerHeight;
    let TotalDistance = ButtonOffSet - TotalElementHeight;

  // console.log(typeof TotalDistance)
    // Log scroll position and total distance (for debugging purposes)
if(isSticky && TotalDistance <= ScrollElement ) {
  return false;
}

    // Check if the scroll position exceeds the distance to make button sticky
    if (ScrollElement >= TotalDistance) {
      
        // Add sticky class if not already added
        if (!$('.sticky--atc-wrapper').hasClass('mobile-sticky')) {
          $('.sticky--atc-wrapper').addClass('mobile-sticky');
          $('.product__info-wrapper').removeClass('scroll-trigger');
          isSticky = true;
        }
    } 
    if(ScrollElement <= TotalDistance){
        // Remove sticky class and revert changes if above threshold
        if ($('.sticky--atc-wrapper').hasClass('mobile-sticky')) {
            $('.sticky--atc-wrapper').removeClass('mobile-sticky');
            $('.product__info-wrapper').addClass('scroll-trigger');
          isSticky = false;
        }
    }
  }
});
}
/* ---------------------------------- */
$(document).on('change','[data-selected-color] select',function(){
  var currentColor  = $(this).val();
   setTimeout(function(){
      $('.related_images [data-image-alt]').removeClass('matched');
      $('.related_images [data-image-alt="not-matched"]').hide();
      $('.related_images [data-image-alt="'+currentColor+'"]').addClass('matched');
   }, 1000);
});
$(document).on('click','.product-form__input--pill[data-selected-color] input[type="radio"]',function(){
  var currentColor  = $(this).val();
   setTimeout(function(){
      $('.related_images [data-image-alt]').removeClass('matched');
      $('.related_images [data-image-alt="not-matched"]').hide();
      $('.related_images [data-image-alt="'+currentColor+'"]').addClass('matched');
   }, 1000);
});
$(document).ready(function(){
  var currentColor  = $('[data-selected-color]').attr('data-selected-color');
   setTimeout(function(){
      $('.related_images [data-image-alt]').removeClass('matched');
      $('.related_images [data-image-alt="not-matched"]').hide();
      $('.related_images [data-image-alt="'+currentColor+'"]').addClass('matched');
   }, 2000);
});